import React from 'react'
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import { formatNumber } from 'src/common/helpers'
import { DailySnapshot, SnapshotStatus } from 'src/common/api'
import { formatRate } from '../../utils'

const headSx = { fontSize: 11, fontWeight: 600, color: 'text.secondary', whiteSpace: 'nowrap' }
const cellSx = { fontSize: 12 }
const totalSx = { borderTop: '2px solid', borderColor: 'divider', fontFamily: 'monospace', fontWeight: 700 }

const SnapshotTable: React.FC<{ snapshots: DailySnapshot[] }> = ({ snapshots }) => {
  const totalDaily = snapshots.reduce((sum, s) => sum + s.dailyRevenueQcad, 0)

  return (
    <Box sx={{ backgroundColor: '#f8fafc', p: 2, borderTop: '1px solid', borderColor: 'divider' }}>
      <Typography
        sx={{
          fontSize: 12,
          fontWeight: 700,
          color: 'text.secondary',
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
          mb: 1
        }}
      >
        Daily Balance Snapshots (4:00 PM EST)
      </Typography>
      <TableContainer
        sx={{
          maxHeight: 320,
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 1,
          backgroundColor: '#fff',
          scrollbarWidth: 'none'
        }}
      >
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell sx={headSx}>Date</TableCell>
              <TableCell sx={headSx}>Snapshot Time</TableCell>
              <TableCell sx={headSx} align="right">
                Balance (QCAD)
              </TableCell>
              <TableCell sx={headSx} align="right">
                Net Rate (Annualized)
              </TableCell>
              <TableCell sx={headSx} align="right">
                Daily QCAD Earned
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {snapshots.map((s) => {
              const active = s.status === SnapshotStatus.ACTIVE
              const opacity = active ? 1 : 0.5
              return (
                <TableRow key={s.date} hover>
                  <TableCell sx={{ ...cellSx, fontWeight: 600, whiteSpace: 'nowrap' }}>{s.date}</TableCell>
                  <TableCell
                    sx={{ ...cellSx, fontFamily: 'monospace', color: 'text.secondary', opacity, whiteSpace: 'nowrap' }}
                  >
                    {active ? s.snapshotTime : '-'}
                  </TableCell>
                  <TableCell align="right" sx={{ ...cellSx, fontFamily: 'monospace', fontWeight: 600, opacity }}>
                    {active ? formatNumber(s.balanceQcad) : '-'}
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={{ ...cellSx, fontFamily: 'monospace', color: 'text.secondary', opacity }}
                  >
                    {active ? formatRate(s.effectiveRate) : '-'}
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={{ ...cellSx, fontFamily: 'monospace', color: 'primary.main', fontWeight: 600, opacity }}
                  >
                    {active ? formatNumber(s.dailyRevenueQcad) : '-'}
                  </TableCell>
                </TableRow>
              )
            })}
            <TableRow>
              <TableCell colSpan={4} sx={{ ...totalSx, fontFamily: 'inherit' }}>
                Total
              </TableCell>
              <TableCell align="right" sx={{ ...totalSx, color: 'primary.main' }}>
                {formatNumber(totalDaily)}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}

export default SnapshotTable
